import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Removes a permission previously granted to a role.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the role.
 * @param permissionUid - Unique identifier of the permission to remove.
 * @returns OperationResult (no payload).
 */
export const deleteRolePermission = async (instance: KyInstance, uid: string, permissionUid: string) => {
  try {
    return await instance.delete<OperationResult>(formatString(Uri.roles.permissionByUid, uid, permissionUid)).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
